import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  scroll() {
    const hero = this.element.parentElement
    const next = hero && hero.nextElementSibling

    if (next) {
      next.scrollIntoView({ behavior: "smooth", block: "start" })
    } else {
      window.scrollBy({ top: window.innerHeight, behavior: "smooth" })
    }
  }
}
